import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { assoc, reduce } from 'ramda';
import { LiveeTagsService, ILiveeTagWrapper } from '../livee.tags.service';
import { SessionBase } from '../session-base';

@Component({
  selector: 'app-features-livee',
  templateUrl: './features.component.html',
  styleUrls: ['./features.component.scss']
})
export class SessionsFeaturesLiveeComponent extends SessionBase implements OnInit {
  private sessionFeaturesTag: ILiveeTagWrapper;
  public sessionFeatures: any = {};
  public previewHash;

  features = [
    { code: 'teasing_questions', name: 'Ack question befire live', label: 'sessions.features.before_live' },
    { code: 'teasing_likes', name: 'Like your favorite question' },
    { code: 'teasing_alert', name: 'Alert-me' },
    { code: 'global_countdown', name: 'Countdown' },

    { code: 'live_video', name: 'Video player', label: 'sessions.features.during_live' },
    { code: ' ', name: 'Chat transcript' },
    // { code: '', name: 'Ask you question' },
    { code: 'live_vote', name: 'Vote/Quiz' },
    { code: 'live_tagcloud', name: 'Tagcloud' },
    { code: 'live_openquestions', name: 'Free answers' },
    { code: 'live_photos', name: 'Sharing photo' },
    { code: 'live_survey', name: 'Survey' },
    { code: 'live_documents', name: 'Downloadable document' },
    // { code: '', name: 'Live viewers stat' },
    // { code: '', name: 'Social app' },

    { code: 'closing_survey', name: 'Survey', label: 'sessions.features.after_live' },
    { code: 'replay_documents', name: 'Downloadable document' },
    { code: 'replay_video', name: 'Video replay' },
    { code: 'replay_chat', name: 'Chat transcript' }
  ];

  constructor(
    private route: ActivatedRoute,
    private liveeTagsService: LiveeTagsService,
    private translateService: TranslateService
  ) {
    super();
  }

  ngOnInit() {
    super.getSession$(this.route.parent.data).subscribe();
    this.loadLiveeTag();
  }
  modified() {
    return this.sessionFeaturesTag ? this.sessionFeaturesTag.modified() : false;
  }

  save() {
    this.liveeTagsService.updateTags(this.session, assoc(this.sessionFeaturesTag.tag.name, this.sessionFeaturesTag, {})).subscribe(
      () => {
        this.previewHash = new Date().getTime();
        toastr.success(this.translateService.instant('action.success'));
      },
      () => {
        toastr.error(this.translateService.instant('action.failed'));
      }
    );
  }

  private loadLiveeTag() {
    this.liveeTagsService.loadTag(this.session, 'session.features').subscribe(ltag => {
      if (!Array.isArray(ltag.value)) {
        ltag.value = this.defaultFeatures();
      }
      this.sessionFeaturesTag = ltag;
      this.sessionFeatures = reduce(
        (acc, feature: any) => {
          return assoc(feature.name, feature, acc);
        },
        {},
        ltag.value
      );
      this.previewHash = new Date().getTime();
    });
  }

  private defaultFeatures() {
    return [
      { name: 'teasing_questions', isActivated: true },
      { name: 'teasing_likes', isActivated: true },
      { name: 'teasing_alert', isActivated: false },
      { name: 'live_video', isActivated: true },
      { name: 'live_chat', isActivated: true },
      { name: 'live_likes', isActivated: false },
      { name: 'live_questions', isActivated: true },
      { name: 'live_nickname', isActivated: true },
      { name: 'live_nicknameEdit', isActivated: false },
      { name: 'live_vote', isActivated: false },
      { name: 'live_tagcloud', isActivated: false },
      { name: 'live_openquestions', isActivated: false },
      { name: 'live_survey', isActivated: false },
      { name: 'live_documents', isActivated: false },
      { name: 'live_viewers', isActivated: true },
      { name: 'live_photos', isActivated: true },
      { name: 'live_socialapp', isActivated: true },
      { name: 'closing_documents', isActivated: true },
      { name: 'closing_survey', isActivated: true },
      { name: 'replay_video', isActivated: true },
      { name: 'replay_chat', isActivated: false },
      { name: 'replay_survey', isActivated: true },
      { name: 'replay_documents', isActivated: true },
      { name: 'global_socials', isActivated: true },
      { name: 'global_copyright', isActivated: true },
      { name: 'global_countdown', isActivated: true }
    ];
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/sessions/features-livee/features.component.ts